{
  "branding": {
    "frontdesk-attribution": "С подкрепата на FrontDesk+",
    "practice-logo": "Лого на {{name}}"
  },
  "validation": {
    "required": "Това поле е задължително",
    "invalid-url": "Моля, въведете валиден URL",
    "pin-too-short": "PIN трябва да съдържа поне 4 символа",
    "pin-default-rejected": "Стандартният PIN 0000 не е разрешен. Моля, задайте свой собствен ПИН.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Назад",
    "next": "Напред",
    "cancel": "Отказ",
    "confirm": "Потвърди",
    "done": "Готово",
    "retry": "Опитай отново",
    "clear": "Изчисти",
    "close": "Затвори",
    "verifying": "Проверка...",
    "select": "Избери",
    "minutes": "минути",
    "clock": "",
    "gender": {
      "M": "Мъж",
      "W": "Жена",
      "D": "Разнообразно",
      "U": "Неизвестно"
    },
    "insurance": {
      "GKV": "Законова",
      "PKV": "Частна",
      "SELFPAY": "Самоплащане"
    },
    "scroll-up": "Превъртане нагоре",
    "scroll-down": "Превъртане надолу"
  },
  "settings": {
    "device-reset": {
      "title": "Нулиране на устройството",
      "description": "Изтриване на връзката с практиката, настройките и ПИН кода на това устройство.",
      "confirmation": "Устройството трябва да се настрои отново. Конфигурацията на SOL и данните за пациентите в inSuite остават непроменени.",
      "cancel": "Отказ",
      "confirm": "Нулиране сега"
    },
    "title": "Настройки",
    "save": "Запази",
    "save-success": "Настройките са запазени",
    "save-error": "Неуспешно запазване на настройките",
    "load-error": "Неуспешно зареждане на настройките",
    "pin": {
      "title": "Необходим е PIN",
      "description": "Моля, въведете вашия PIN за достъп до настройките.",
      "error": "Грешен PIN. Моля, опитайте отново.",
      "backspace": "Изтрий последната цифра"
    },
    "connection": {
      "title": "Връзка",
      "description": "Настройки за връзка със сървъра Doc-Cirrus Bridge",
      "bridge-url": "URL на Bridge",
      "device-name": "Име на устройството",
      "device-name-placeholder": "напр. Рецепция, стая 1, павилион",
      "device-name-hint": "Име за идентификация в таблото Bridge",
      "kim-address": "KIM адрес (по избор)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Тест",
      "success": "Връзката е успешна",
      "error": "Връзката е неуспешна",
      "api-unreachable": "DocCirrus API недостъпен",
      "status-title": "Състояние на връзката",
      "status": {
        "api": "API е свързан",
        "ti": "Телематична инфраструктура",
        "card-reader": "Наличен четец на карти",
        "medical-card": "Карта на лекарския кабинет (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol токен (от inSuite)",
      "sol-token-hint": "Копирайте го от управлението на Bridge в inSuite. Нужен е за връзката.",
      "sol-token-show": "Покажи токена",
      "sol-token-hide": "Скрий токена",
      "bridge-unreachable": "Bridge е недостъпен. Проверете адреса и порта.",
      "diagnostic-id": "Диагностичен ID: {{id}}",
      "scan-qr": "Сканирай QR код",
      "scan-title": "Сканирай QR кода на Bridge",
      "scan-manual": "Въведи ръчно"
    },
    "terminal": {
      "title": "Четец на карти",
      "description": "Избор на четец на карти за телематичната инфраструктура",
      "select": "Избери терминал",
      "select-placeholder": "Избери терминал...",
      "loading": "Зареждане на терминали...",
      "none-available": "Няма налични терминали",
      "none-found": "Не са намерени терминали",
      "found": "Намерени {{count}} терминал(и)",
      "connect-hint": "Първо се свържете със сървъра bridge, за да заредите терминалите.",
      "found-count": "Намерени четци на карти: {{count}}",
      "refresh": "Презареди четците на карти"
    },
    "practice": {
      "title": "Лекарски кабинет",
      "description": "Информация за вашия лекарски кабинет",
      "name": "Име на лекарския кабинет",
      "name-placeholder": "напр. Д-р Иван Иванов",
      "welcome-message": "Приветствено съобщение",
      "welcome-placeholder": "напр. Добре дошли в нашия лекарски кабинет",
      "scheduler-available": "Активирайте Scheduler",
      "scheduler-available-description": "Позволете на пациентите да резервират срещи чрез терминала за самообслужване",
      "prescription-available": "Активирайте услугата за рецепта",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Оставете празно, за да се показва поздравът на езика на пациента. Вашият собствен текст се показва непроменен на всички езици."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Запазено за всички устройства на {{value}}",
      "never-saved-default": "Настройка по подразбиране, още непроменена."
    },
    "anamnesis": {
      "title": "Дигитална медицинска история",
      "description": "Показва връзка и QR code към вашия доставчик на медицинска история след регистрация.",
      "enabled": "Показване на връзка към медицинска история след настаняване",
      "enabled-description": "Показва връзка и QR code към вашия доставчик на медицинска история след завършено регистриране, например Nelly.",
      "url": "Връзка към доставчик на медицинска история",
      "url-hint": "Връзката е статична и еднаква за всички пациенти.",
      "preview-label": "Визуализация на екрана за завършване",
      "preview-note": "Връзката е статична и еднаква за всички пациенти.",
      "url-first": "За да включите, първо въведете валидна връзка."
    },
    "appearance": {
      "title": "Външен вид",
      "description": "Персонализирайте потребителския интерфейс",
      "language": "Език",
      "default-kiosk-language": "Език на пациента по подразбиране",
      "default-kiosk-language-hint": "Език, на който започват новите павилионни сесии за пациентите.",
      "voice-over-volume": "Сила на гласа зад кадър",
      "voice-over-hint": "Управлява силата на звука на гласовия асистент за достъпност.",
      "language-first": "Показване на избор на език в началото на сесията"
    },
    "security": {
      "title": "Сигурност",
      "description": "PIN за достъп до настройките",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Управление на киоска",
    "nav": {
      "general": "Общи",
      "flows": "Функции",
      "anamnese": "Дигитална анамнеза",
      "device": "Устройство и връзка"
    },
    "flows": {
      "title": "Функции на терминала"
    },
    "language": {
      "title": "Език и озвучаване",
      "description": "Език и четене на глас за пациентите на това устройство."
    }
  },
  "self-service": {
    "title": "Самообслужване",
    "step-progress": "Стъпка {{current}} / {{total}}",
    "flows": {
      "checkin": "Регистрация",
      "scheduler": "Запази час",
      "prescription": "Предписания",
      "locations": "Карта на локацията",
      "emergency": "Спешност"
    },
    "audio-guide": {
      "on": "Звук включен",
      "off": "Звук изключен",
      "replay": "Повтори указанията",
      "replay-unavailable": "Няма гласови указания за повторение"
    },
    "language-selector": {
      "title": "Изберете език",
      "description": "Моля, изберете предпочитания език"
    },
    "settings": "Настройки",
    "start": {
      "welcome": "Добре дошли",
      "subtitle": "Моля, изберете опция",
      "check-in-label": "Главен път",
      "check-in-cta": "Регистрация",
      "check-in-description": "Вече имате час? Регистрирайте се тук.",
      "check-in-hint": "Подгответе картата си",
      "scheduler-label": "Нов",
      "scheduler-cta": "Запази час",
      "scheduler-description": "Насрочете нов час.",
      "location-plan": "Карта на локацията",
      "location-plan-description": "Намерете пътя до стаята за лечение.",
      "prescription-label": "Предписание",
      "prescription-cta": "Рецепти и поръчки",
      "prescription-description": "Вижте рецепти или поръчайте пълнители.",
      "emergency-cta": "Локална аварийна сигнализация",
      "emergency-description": "Звучи само на това устройство и не вика помощ.",
      "tap-to-start": "Докоснете, за да започнете"
    },
    "offline": {
      "banner-title": "Временно няма възможност за настаняване",
      "banner-message": "Моля, говорете с персонала на рецепцията за съдействие.",
      "emergency-available": "Локалната сигнализация остава достъпна. Тя не вика помощ.",
      "flow-disabled": "Временно недостъпен"
    },
    "readability": {
      "toggle-label": "Режим на четене",
      "on": "Режим на четене",
      "off": "Режим на четене"
    },
    "reset-overlay": {
      "timeout-title": "Сесията приключи",
      "timeout-subtitle": "Времето ви изтече. Вашите данни са в безопасност.",
      "offline-title": "Връзката е прекъсната",
      "offline-subtitle": "Връзката беше прекъсната. Моля, говорете с персонала на рецепцията.",
      "interruption-title": "Сесията приключи",
      "interruption-subtitle": "Вашата сесия приключи безопасно.",
      "completion-title": "благодаря ви",
      "completion-subtitle": "Вашата заявка е изпълнена успешно.",
      "reassurance": "Вашите лични данни не се съхраняват на това устройство.",
      "auto-dismiss": "Връщане в началото след {{seconds}} секунди...",
      "dismiss": "Отидете, за да започнете"
    },
    "timed-terminal": {
      "countdown": "Автоматично връщане за {{seconds}} секунди",
      "countdown-outcome": "Този терминал автоматично ще се върне към началния екран.",
      "more-time": "Повече време",
      "extended": "Времето е удължено"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Тези въпроси не са налични на Вашия език. Изберете един от предложените езици или се обърнете към регистратурата.",
        "alternatives": "Алтернативни часове",
        "loading": "Зареждане на въпросите…",
        "reception-fallback": "Моля, обърнете се към рецепцията.",
        "error-title": "Въпросите не можаха да бъдат заредени",
        "language-unavailable-lead": "Тези въпроси не са налични на вашия език.",
        "language-unavailable-title": "Моля, изберете един от тези езици",
        "language-unavailable-body": "Или помолете за помощ на рецепцията."
      },
      "start": {
        "title": "Запази час",
        "subtitle": "Запазете предпочитания час в няколко стъпки",
        "welcome": "Добре дошли в резервацията на часове",
        "description": "Ще ви водим през процеса на резервация",
        "cta": "Запази час сега"
      },
      "patient-id": {
        "title": "Идентификация",
        "subtitle": "Моля, идентифицирайте се",
        "mode-card": "С карта",
        "mode-search": "Търсене",
        "mode-create": "Създай нов",
        "insert-card": "Моля, поставете вашата здравна карта",
        "reading-card": "Четене на карта...",
        "simulate-card": "Симулирай карта",
        "multiple-matches": "Намерени са множество пациенти. Използват се данни от картата.",
        "search-placeholder": "Име или номер на осигуровка...",
        "searching": "Търсене...",
        "no-results": "Няма намерени резултати",
        "first-name": "Име",
        "last-name": "Фамилия",
        "dob": "Дата на раждане",
        "insurance": "Осигуровка",
        "continue": "Продължи",
        "creating": "Създаване на пациент...",
        "patient-created": "Пациентът е създаден успешно!",
        "create-error": "Пациентът не можа да бъде създаден."
      },
      "appointment-type": {
        "title": "Изберете тип час",
        "subtitle": "Моля, изберете причината за вашето посещение",
        "loading": "Зареждане на типове часове...",
        "no-types": "Няма налични типове часове",
        "error": "Неуспешно зареждане на типовете часове. Моля, опитайте отново.",
        "no-bookable": "Тези видове часове в момента не могат да се резервират от киоска. Моля, обърнете се към регистратурата или запазете час по телефона.",
        "disabled-default": "Моля, запазете този час директно на регистратурата или по телефона.",
        "disabled-footer": "Само регистратура/телефон",
        "lead": "Какъв вид час искате да запазите?",
        "duration": "ок. {{minutes}} минути",
        "empty-title": "В момента тук не може да се запазват часове",
        "none-bookable-title": "Тези часове не могат да се запазят тук",
        "none-bookable-body": "Моля, попитайте на рецепцията или ни се обадете."
      },
      "types": {
        "general": "Общ преглед",
        "general-desc": "За общи оплаквания и въпроси",
        "checkup": "Профилактичен преглед",
        "checkup-desc": "Редовни здравни прегледи",
        "vaccination": "Ваксинация",
        "vaccination-desc": "Насрочете ваксинация",
        "followup": "Проследяване",
        "followup-desc": "Контролен час",
        "prescription": "Рецепта",
        "prescription-desc": "Вземане на рецепта"
      },
      "slot-selection": {
        "title": "Изберете час",
        "subtitle": "Моля, изберете наличен час",
        "loading": "Зареждане на налични часове...",
        "no-slots": "Няма налични часове",
        "no-appointment-type": "Не е избран тип час",
        "error": "Неуспешно зареждане на наличните часове. Моля, опитайте отново.",
        "quick-select": "Следващи налични часове:",
        "select-date": "Или изберете дата:",
        "times-for": "{{date}}",
        "available": "Наличен",
        "unavailable": "Няма часове",
        "slots": "часове",
        "select-time-hint": "Докоснете час, за да запазите",
        "week-short": "Седм",
        "weekday-mon": "Пон",
        "weekday-tue": "Вт",
        "weekday-wed": "Ср",
        "weekday-thu": "Чет",
        "weekday-fri": "Пет",
        "weekday-sat": "Съб",
        "weekday-sun": "Нед",
        "period-morning": "Сутрин",
        "period-midday": "Обяд",
        "period-afternoon": "Следобед",
        "period-evening": "Вечер",
        "period-morning-short": "Сутр.",
        "period-midday-short": "Обяд",
        "period-afternoon-short": "Следоб.",
        "period-evening-short": "Вечер",
        "period-dots-legend": "Наличност по време",
        "filter-hint": "Филтрирай по предпочитани часове:",
        "or-choose-below": "или изберете по-долу",
        "no-slots-period": "Без слотове",
        "show-all": "Покажи всички",
        "free": "безплатно",
        "your-selection": "Вашият избор",
        "oclock": "часа",
        "choose-slot": "Изберете слот",
        "choose-day": "Изберете ден",
        "choose-day-first": "Моля, първо изберете ден",
        "times-heading": "Свободни часове на {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Няма свободни часове през {{month}}",
        "empty-body": "Вижте следващия месец или попитайте на рецепцията – с удоволствие ще помогнем.",
        "next-month": "Следващ месец",
        "previous-month": "Предишен месец"
      },
      "confirmation": {
        "patient-responses": "Вашите отговори",
        "review-loading": "Проверка на обобщението…",
        "review-unavailable": "Обобщението не е налично. Моля, опитайте отново или попитайте на рецепцията.",
        "check-booking": "Проверка на резервацията",
        "title": "Потвърди час",
        "subtitle": "Моля, прегледайте резервацията си",
        "patient": "Пациент",
        "datetime": "Дата и час",
        "booking": "Резервиране...",
        "confirm": "Запази час",
        "heading": "Правилно ли изглежда това?",
        "lead": "Моля, потвърдете вашия час.",
        "appointment": "Назначаване",
        "insured-via": "Застраховани чрез",
        "description-label": "Бележки за кабинета (по избор)",
        "description-hint": "Кажете ни, ако има нещо, което трябва да вземем предвид при записването на час или при регистрацията.",
        "description-placeholder": "напр. ограничена подвижност, придружител, важни бележки",
        "description-too-long": "Моля, съкратете бележката до най-много 500 знака.",
        "summary": "Резюме",
        "change": "промяна",
        "book-binding": "Запазете час",
        "cancel": "Отказ",
        "type-label": "Вид на часа",
        "datetime-value": "{{date}} в {{time}}",
        "name-label": "Име",
        "insurance-label": "Осигуровка",
        "insurance-GKV": "Задължителна здравна осигуровка",
        "insurance-PKV": "Частна здравна осигуровка",
        "insurance-SELFPAY": "Самоплащащ",
        "change-time": "Промяна на часа",
        "description-free-text": "Други бележки (по избор)",
        "note-wheelchair": "Използвам инвалидна количка",
        "note-companion": "Идвам с придружител",
        "note-interpreter": "Нуждая се от преводач"
      },
      "done": {
        "title": "Часът е запазен!",
        "label": "Резервирано",
        "subtitle": "Вашият час е успешно запазен.",
        "date": "Дата",
        "time": "Час",
        "booking-id": "Номер на резервация",
        "qr-hint": "Добави в календара",
        "qr-description": "Сканирайте този QR код с камерата на вашия смартфон, за да добавите часа в приложението си за календар",
        "auto-redirect": "Скоро ще бъдете пренасочени към началната страница...",
        "auto-redirect-countdown": "Връщане към начало след {{seconds}} секунди...",
        "back-to-start": "Обратно към начало",
        "print-button": "Отпечатване на бележка за часа",
        "print-preparing": "Подготвяне на изгледа за печат…",
        "print-error": "Бележката за часа не можа да бъде отворена. Опитайте отново или потърсете помощ на регистратурата.",
        "print-returned": "Системният изглед за печат беше затворен. При нужда можете да заявите друго копие.",
        "print-title": "Вашият час",
        "print-location": "Местоположение",
        "print-map-hint": "Отворете местоположението на телефона си",
        "print-error-v2": "Бележката за часа не можа да се отвори. Моля, опитайте отново или попитайте на рецепцията."
      },
      "error": {
        "assistance-info": "Не успяхме да потвърдим резервацията ви. Часът ви може вече да е запазен. Моля, попитайте на рецепцията.",
        "pending-title": "Резервацията не е потвърдена",
        "pending-info": "Не успяхме да потвърдим резервацията ви. Часът ви може вече да е запазен. Моля, проверете отново или попитайте на рецепцията.",
        "title": "Неуспешна резервация",
        "subtitle": "Часът не можа да бъде запазен.",
        "info": "Моля, опитайте отново или попитайте на рецепцията."
      },
      "phase": {
        "identify": "Регистрация",
        "choose": "Избор на час",
        "confirm": "Потвърждение"
      }
    },
    "prescription": {
      "start": {
        "title": "Рецепти и поръчки",
        "subtitle": "Поставете вашата застрахователна карта, за да видите рецепти или да поръчате пълнители.",
        "button": "Поставете карта"
      },
      "card-check": {
        "loading": "Четецът на карти се зарежда...",
        "no-terminal": "Няма конфигуриран четец на карти",
        "no-terminal-hint": "Моля, свържете се с персонала за помощ.",
        "insert-card": "Моля, поставете вашата карта",
        "insert-card-hint": "Поставете вашата застрахователна карта в четеца на карти.",
        "card-detected": "Картата е открита",
        "reading": "Карта за четене...",
        "reading-hint": "Моля, изчакайте малко.",
        "error": "Грешка при четене на картата",
        "retry": "Опитайте отново",
        "manual-lookup": "Продължете без карта",
        "load-error": "Четецът на карти не можа да се зареди",
        "read-error": "Картата не може да бъде прочетена"
      },
      "patient-selection": {
        "title": "Изберете Пациент",
        "subtitle": "Открити са множество пациенти. Моля, изберете вашето име.",
        "try-again": "Опитайте отново",
        "try-again-hint": "Поставете отново картата"
      },
      "list": {
        "title": "Вашите предписания",
        "for-patient": "Предписания за {{name}}",
        "loading": "Рецептите се зареждат...",
        "error-title": "Грешка при зареждане",
        "fetch-error": "Рецептите не можаха да бъдат заредени",
        "back-home": "Назад към Старт",
        "done": "Готово"
      },
      "detail": {
        "prescription-info": "Информация за рецепта",
        "date": "Дата",
        "prescriber": "Предписващ",
        "comment": "Забележка",
        "medications": "лекарства",
        "form": "форма",
        "pack-size": "Размер на опаковката",
        "manufacturer": "производител",
        "loading": "Зареждане на рецептата...",
        "fetch-error": "Подробностите за рецептата не можаха да бъдат заредени",
        "back-to-list": "Назад към списъка",
        "print": "Печат"
      },
      "types": {
        "public": "Публично предписание",
        "private": "Частна рецепта",
        "long-term": "Дългосрочна рецепта",
        "btm": "Наркотична рецепта",
        "g": "Зелена рецепта",
        "t": "Т-рецепта"
      },
      "no-patient": {
        "title": "Пациентът не е намерен",
        "subtitle": "За съжаление не беше намерен пациент за тази карта. Моля, свържете се с персонала за помощ.",
        "try-again": "Опитайте отново",
        "back-home": "Назад към Старт",
        "title-v2": "Няма съответстващи данни",
        "subtitle-v2": "Не успяхме да ви намерим. Моля, опитайте отново или попитайте на рецепцията."
      },
      "done": {
        "title": "благодаря ви",
        "subtitle": "Можете да седнете сега. Ако имате въпроси, моля свържете се със служителите.",
        "no-prescriptions-title": "Няма регистрирани рецепти",
        "no-prescriptions-subtitle": "Не успяхме да намерим активни рецепти за вас. Ако очаквате такъв, моля, свържете се с персонала на рецепцията.",
        "error-title": "Възникна грешка",
        "error-subtitle": "Моля, свържете се с персонала за допълнителна помощ.",
        "auto-redirect": "Автоматично пренасочване за {{seconds}} секунди",
        "finish": "Назад към Старт"
      },
      "hub": {
        "title": "Вашите предписания",
        "for-patient": "Предписания за {{name}}",
        "loading": "Рецептите се зареждат...",
        "error-title": "Грешка при зареждане",
        "fetch-error": "Рецептите не можаха да се заредят",
        "back-home": "Назад към Старт",
        "done": "Готово",
        "order-button": "Рецепта за поръчка",
        "existing-prescriptions": "Вашите текущи рецепти",
        "no-prescriptions": "Няма намерени активни рецепти."
      },
      "patient-lookup": {
        "title": "Намерете пациент",
        "subtitle": "Въведете вашето име и дата на раждане.",
        "last-name": "Фамилия",
        "first-name": "Първо име",
        "date-of-birth": "Дата на раждане",
        "lastname": "Фамилия",
        "lastname-placeholder": "Вашето фамилно име",
        "firstname": "Първо име",
        "firstname-placeholder": "Вашето малко име",
        "dob": "Дата на раждане",
        "search": "Търсене",
        "searching": "Търсене...",
        "search-error": "Грешка при търсене: {{message}}",
        "no-match": "Няма открит пациент. Моля, проверете информацията си.",
        "error": "Грешка при търсене. Моля, опитайте отново.",
        "found": "Намерен пациент",
        "confirm": "Потвърдете",
        "ambiguous": "Множество съвпадения",
        "ambiguous-hint-firstname": "Моля, въведете също собственото си име, за да прецизирате търсенето.",
        "ambiguous-hint-additional": "Моля, проверете информацията си или се свържете с персонала.",
        "not-found": "Пациентът не е намерен",
        "not-found-hint": "Нито един пациент не може да бъде намерен с тези данни.",
        "not-found-action": "Опитайте отново"
      },
      "manual-identification": {
        "unverified": "Самоличността ви не е потвърдена със здравноосигурителната карта. Практиката ще провери данните и заявката ви преди обработка."
      },
      "medication-selection": {
        "title": "Поискайте рецепта",
        "subtitle": "Лекарският кабинет разглежда заявката ви. След одобрение eRx ще бъде готово във вашето приложение e-prescription.",
        "back": "Назад",
        "submit": "Продължете с прегледа",
        "reason-title": "Защо ви е необходима рецептата?",
        "reason-hint": "Помага на лекарския кабинет да оцени заявката ви.",
        "reason-validation": "Моля, изберете причина.",
        "reason-schmerzen": "болка",
        "reason-entzuendung": "Възпаление",
        "reason-nachsorge": "След операция/процедура",
        "reason-allergie": "Алергия / реакция",
        "reason-chronisch": "Хронично състояние",
        "reason-anderes": "Нещо друго",
        "medications-title": "Кои лекарства?",
        "request-hint": "Опишете от какво се нуждаете или назовете предишната рецепта, която искате да подновите.",
        "request-placeholder": "напр. Ибупрофен 600 mg, същото като последния път",
        "request-validation": "Моля, опишете от какви лекарства се нуждаете.",
        "history-title": "Предишни предписания",
        "history-hint": "Добавете запис, за да попълните предварително вашата заявка.",
        "history-loading": "Зареждат се предишни рецепти...",
        "history-error": "Предишни предписания не можаха да бъдат заредени.",
        "history-add": "Добавете",
        "history-added": "Добавено",
        "history-date": "Последно: {{date}}",
        "history-request-line": "Подновяване: {{medicationName}}",
        "urgency-title": "Колко спешно е?",
        "urgency-hint": "Помага на лекарския кабинет да определи приоритета.",
        "urgency-soon": "Спешно",
        "urgency-soon-meta": "При първа възможност",
        "urgency-tomorrow": "Скоро",
        "urgency-tomorrow-meta": "В следващите дни",
        "urgency-week": "Тази седмица",
        "urgency-week-meta": "Без времеви натиск",
        "lead": "Практиката ще прегледа заявката ви. След одобрение ще намерите е-рецептата си в приложението за е-рецепти или на здравноосигурителната си карта.",
        "history-hint-v2": "Докоснете предишна рецепта, за да я добавите.",
        "history-retry": "Зареди отново"
      },
      "request-review": {
        "title": "Преглед на поръчката",
        "subtitle": "Моля, прегледайте вашата заявка за рецепта.",
        "request-label": "Поискано лекарство",
        "selected-medications": "Избрани лекарства",
        "free-text-medications": "Допълнителни лекарства",
        "freetext-label": "други",
        "quarterly-warning": "Вашата здравноосигурителна карта не е прочетена през това тримесечие. Лекарският кабинет може да се свърже с вас.",
        "egk-warning": "Вашата здравноосигурителна карта не е прочетена през това тримесечие. Лекарският кабинет може да се свърже с вас.",
        "submit": "Изпратете",
        "submitting": "Изпраща се...",
        "submit-error": "Заявката не можа да бъде изпратена. Моля, опитайте отново.",
        "back": "Назад",
        "reason-label": "Причина",
        "urgency-label": "Спешност",
        "completion-email-choice": "Искам да получа имейл, когато практиката обработи заявката ми.",
        "completion-email-label": "Имейл адрес",
        "completion-email-placeholder": "ime@example.com",
        "completion-email-hint": "Само за това еднократно съобщение. Адресът не се записва в основните данни.",
        "completion-email-invalid": "Моля, въведете валиден имейл адрес.",
        "egk-proof-required": "Заявките за рецепта са възможни само след успешно прочитане на здравноосигурителната карта. Моля, обърнете се към персонала.",
        "title-v2": "Проверка на заявката",
        "completion-email-hint-v2": "Адресът се използва само за това едно съобщение."
      },
      "confirmation": {
        "title": "Заявката е изпратена",
        "subtitle": "Вашата заявка за рецепта е изпратена успешно.",
        "success-title": "Заявката е изпратена",
        "success-subtitle": "Вашата заявка за рецепта е изпратена успешно.",
        "estimated-time": "Вашата рецепта ще бъде готова след приблизително {{time}}.",
        "info": "Можете да вземете рецептата си в аптеката с вашата застрахователна карта или приложението eRezept.",
        "auto-redirect": "Автоматично пренасочване за {{seconds}} секунди",
        "back-to-start": "Назад към Старт",
        "handling-label": "Handled by the practice",
        "next-steps": "Практиката ще прегледа заявката ви. След одобрение можете да получите е-рецептата си в аптеката със здравноосигурителната карта или приложението за е-рецепти."
      },
      "phase": {
        "identify": "Регистрация",
        "request": "Заявка",
        "review": "Проверка"
      }
    },
    "check-in": {
      "flow-label": "Настаняване",
      "has-appointment": {
        "eyebrow": "Назначаване",
        "title": "Имате ли час?",
        "subtitle": "Моля, изберете опция",
        "yes-label": "да",
        "yes": "Да, имам час",
        "yes-description": "Искам да се регистрирам за моя час.",
        "yes-hint": "Най-бързият път",
        "unsure-label": "може би",
        "unsure": "Не съм сигурен",
        "unsure-description": "Ще проверим за вас.",
        "unsure-hint": "Ще те потърсим",
        "no-label": "не",
        "no": "Не, без час",
        "no-description": "Нямам час.",
        "no-hint": "Разходка"
      },
      "card-check": {
        "eyebrow": "Застрахователна карта",
        "title": "Прочети здравна карта",
        "subtitle": "Моля, поставете вашата здравна карта в четеца",
        "insert-title": "Поставете здравноосигурителната си карта в четеца.",
        "insert-detail": "Ние четем вашите данни автоматично - не е необходимо да правите нищо друго.",
        "other-ways": "Други начини",
        "no-card-hint": "Ако не носите картата си в момента.",
        "pkv-hint": "Използвайте QR code с вашето застрахователно приложение.",
        "loading": "Зареждане на настройки...",
        "no-terminal": "Няма конфигуриран четец на карти. Моля, свържете се с персонала.",
        "checking": "Проверка за карти...",
        "insert-prompt": "Моля, поставете карта...",
        "card-detected": "Картата е открита! Готова за четене.",
        "read-card": "Прочети карта",
        "simulate-insert": "Симулирай карта",
        "reading": "Четене на карта...",
        "error": "Неуспешно четене на картата. Моля, опитайте отново.",
        "read-error": "Неуспешно четене на данните от картата. Моля, опитайте отново.",
        "settings-error": "Неуспешно зареждане на настройките. Моля, опитайте отново.",
        "no-card-prompt": "Нямате карта?",
        "no-card-action": "Ръчно търсене",
        "connection-warning": "Проблеми с връзката с четеца на карти. моля изчакайте...",
        "pkv-prompt": "Частна застраховка? Online Check-in",
        "pkv-instruction": "Сканирайте този QR code с приложението за частно здравно осигуряване, за да прехвърлите данните си цифрово.",
        "pkv-continue": "Продължете към ръчна регистрация",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Опитайте отново или се регистрирайте без карта. Рецепцията ще ви помогне с удоволствие.",
        "title-pkv": "Регистрация с приложение",
        "title-reading": "Картата ви се чете …",
        "title-unreadable": "Картата не можа да бъде прочетена",
        "title-no-terminal": "Регистрация без карта",
        "no-terminal-body": "Четецът на карти в момента не е наличен. Регистрирайте се без карта или се обърнете към рецепцията.",
        "reading-detail": "Оставете картата в четеца. Това отнема само миг.",
        "other-ways-title": "Други възможности",
        "no-card-title": "Регистрация без карта",
        "pkv-prompt-title": "С частна осигуровка?",
        "pkv-prompt-hint": "Регистрация с приложението на частната ви здравна осигуровка",
        "pkv-close": "Все пак с карта",
        "pkv-instruction-app": "Отворете приложението на частната си здравна осигуровка и сканирайте този код. Данните ви идват директно при нас."
      },
      "patient-selection": {
        "title": "Изберете пациент",
        "subtitle": "Намерени са множество пациенти. Моля, изберете себе си.",
        "firstname-label": "Вашето малко име",
        "firstname-placeholder": "Въведете собствено име...",
        "confirm-button": "Потвърдете",
        "no-match": "Не е намерен съответстващ пациент. Моля, отидете на рецепцията за съдействие.",
        "still-ambiguous": "Остават множество мачове. Моля, отидете на рецепцията за съдействие.",
        "select-error": "Неуспешно идентифициране на пациента. Моля, опитайте отново.",
        "staff-assist": "Отидете на рецепцията",
        "title-v2": "Кратък въпрос",
        "subtitle-v2": "За сигурност въведете малкото си име.",
        "no-match-v2": "Не ви открихме с това име. Проверете изписването или се обърнете към рецепцията.",
        "still-ambiguous-v2": "Все още не можем да ви открием еднозначно. Обърнете се към рецепцията.",
        "select-error-v2": "За съжаление не се получи. Опитайте отново."
      },
      "card-checkin": {
        "title": "Потвърди регистрация",
        "subtitle": "Вашите данни са успешно прочетени.",
        "confirm": "Потвърди регистрация"
      },
      "register-from-card": {
        "title": "Нова регистрация",
        "subtitle": "Все още не сте в нашата система. Искате ли да се регистрирате?",
        "card-data": "Данни на картата",
        "create": "Регистрирай се",
        "create-error": "Регистрацията е неуспешна. Моля, опитайте отново или помолете персонала за помощ.",
        "staff-assist": "Обадете се на персонала",
        "no-card-data-title": "Няма данни за картата",
        "no-card-data": "Не могат да се прочетат данни от вашата карта.",
        "insurance-verified": "Проверена застраховка: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Вашите данни от картата",
        "subtitle-v2": "Проверете данните си. Ако нещо не е вярно, докоснете „Промяна“.",
        "create-v2": "Потвърдете данните",
        "create-error-v2": "Регистрацията за съжаление не се получи. Опитайте отново или се обърнете към рецепцията.",
        "insurer-missing-v2": "На картата ви липсва информация за здравната каса. Обърнете се към рецепцията.",
        "edit": "Промяна",
        "name": "Име",
        "insurer": "Здравна каса"
      },
      "patient-lookup": {
        "title": "Търсене на пациент",
        "subtitle": "Моля, въведете вашето име или номер на осигуровка.",
        "lastname": "Фамилия",
        "lastname-placeholder": "Вашето фамилно име",
        "dob": "Дата на раждане",
        "firstname": "Първо име",
        "firstname-placeholder": "Вашето малко име",
        "search": "Търсене",
        "searching": "Търсене...",
        "search-placeholder": "Име или номер на осигуровка...",
        "results-placeholder": "Резултатите от търсенето ще се появят тук",
        "found": "Пациентът е намерен!",
        "confirm-identity": "Моля, потвърдете, че вие сте показаният пациент.",
        "confirm-button": "това съм аз",
        "ambiguous-firstname": "Открити са множество пациенти. Моля, въведете собственото си име.",
        "ambiguous-additional": "Открити са множество пациенти. Моля, свържете се със служителите.",
        "disambiguation-hint": "Това ни помага да ви идентифицираме ясно.",
        "not-found": "Не е намерен пациент с тези данни.",
        "error": "Грешка при търсене: {{message}}",
        "staff-assist": "Обадете се на персонала",
        "not-found-prompt": "Не е намерено?",
        "register-new": "Регистрирай нов",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Регистрация без карта",
        "subtitle-firstname": "Въведете и малкото си име.",
        "ambiguous-firstname-v2": "Има няколко души с тази фамилия. Въведете и малкото си име.",
        "search-again": "Търсене отново",
        "found-v2": "Открихме ви",
        "found-confirm": "Потвърдете с „Това съм аз“.",
        "not-found-title": "Не ви открихме",
        "not-found-check": "Проверете изписването и датата на раждане. Рецепцията ще ви помогне с удоволствие.",
        "not-found-reception": "Проверете изписването и датата на раждане или се обърнете към рецепцията.",
        "ambiguous-additional-v2": "Не можахме да ви открием еднозначно. Обърнете се към рецепцията.",
        "error-v2": "Търсенето в момента не се получи. Опитайте отново."
      },
      "checking-in": {
        "title": "Един момент — настаняваме ви.",
        "subtitle": "Добавяме ви към опашката за лечение и уведомяваме екипа.",
        "step-insurance": "Застраховката е проверена",
        "step-appointment": "Назначаването е потвърдено",
        "step-waitlist": "Добавяне към списъка с чакащи",
        "error": "Неуспешно настаняване. Моля, опитайте отново.",
        "continue": "Продължете все пак",
        "title-v2": "Един момент, моля",
        "loading": "Регистрираме ви …",
        "subtitle-v2": "Записваме ви в списъка на чакащите и уведомяваме екипа.",
        "error-title": "За съжаление не се получи",
        "error-v2": "Регистрацията ви не можа да бъде завършена.",
        "error-body": "Опитайте отново. Ако пак не стане, рецепцията ще ви помогне."
      },
      "appointment-selection": {
        "title": "Изберете среща",
        "subtitle": "Имате няколко срещи днес. Моля, изберете един.",
        "checking-in": "Настаняване...",
        "time": "{{time}} ч.",
        "error-v2": "Регистрацията за този час не се получи. Опитайте отново или се обърнете към рецепцията."
      },
      "no-appointment": {
        "title": "Няма намерена среща",
        "subtitle": "Не успяхме да намерим час за вас днес. Моля, запишете редовен час.",
        "book-appointment": "Запазете час",
        "book-appointment-description": "Резервирайте нов час чрез редовния график.",
        "staff-assist": "Обадете се на персонала",
        "staff-assist-description": "Имам нужда от помощ.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Днес не открихме час за вас.",
        "book-v2": "Запишете нов час",
        "book-v2-description": "Изберете сега свободен час.",
        "have-appointment": "Имам записан час",
        "have-appointment-description": "Рецепцията ще ви помогне с удоволствие.",
        "unavailable-title": "Моля, записвайте часове на рецепцията",
        "subtitle-unavailable": "Днес не открихме час за вас. Обърнете се към рецепцията."
      },
      "staff-assist": {
        "title": "Персоналът е уведомен",
        "subtitle": "Служител ще ви помогне скоро.",
        "message": "Моля, изчакайте тук. Член на персонала ще бъде с вас скоро.",
        "start-over": "Назад към началото",
        "auto-redirect": "Връщане в началото след {{seconds}} секунди..."
      },
      "eeb-prompt": {
        "title": "Провери осигуровка",
        "title-failed": "Неуспешна проверка",
        "subtitle": "Как искате да проверите вашата осигуровка?",
        "subtitle-failed": "Сканирайте QR кода с вашето приложение за осигуровка, за да поискате проверка.",
        "verify-card": "Провери електронно",
        "verify-card-description": "Изпратете заявка до вашия осигурител.",
        "select-insurer": "Изберете осигурител",
        "select-insurer-description": "Ръчен избор на вашия осигурител.",
        "skip": "Пропусни",
        "eyebrow-chip": "алтернатива",
        "eyebrow": "Настаняване · доказателство за застраховка (eEB)",
        "recommended": "Препоръчва се",
        "qr-title": "Сканирайте с вашето застрахователно приложение",
        "qr-description": "Отворете вашето приложение за здравно осигуряване и сканирайте кода — eEB се изпраща директно до нас.",
        "qr-address-label": "Изпрати до",
        "title-app": "Удостоверение чрез приложение",
        "subtitle-app": "Здравната ви каса може и да ни изпрати удостоверението директно. Когато сте готови, докоснете „Напред“."
      },
      "quarterly-check": {
        "title": "Проверка на осигуровка",
        "checking": "Проверяваме вашата текуща проверка на осигуровката...",
        "error": "Проверката не можа да бъде извършена.",
        "title-v2": "Вашата осигуровка",
        "checking-v2": "Проверяваме осигуровката ви – един момент, моля.",
        "error-body": "Регистрацията ви е готова. Рецепцията ще изясни осигуровката с вас."
      },
      "insurer-prefilled": {
        "title": "Вашата здравна осигуровка",
        "subtitle": "Моля, потвърдете вашата осигуровка за това тримесечие.",
        "your-insurance": "Вашата осигуровка",
        "last-read": "Последна проверка на {{date}}",
        "quarterly-notice": "За целите на фактурирането ни е необходимо актуално доказателство за осигуровка за това тримесечие.",
        "confirm-button": "Да, това е моята осигуровка",
        "change-button": "Имам друга осигуровка",
        "contact-title": "Поискайте електронно доказателство за покритие",
        "contact-description": "Обадете се на вашата застраховка и поискайте електронно доказателство за покритие за:",
        "contact-patient": "пациент",
        "contact-kim-address": "KIM адрес на лекарския кабинет",
        "contact-phone": "Телефон",
        "question": "Това ли е вашата здравна каса?",
        "quarterly-notice-v2": "Веднъж на тримесечие се нуждаем от удостоверение от здравната ви каса."
      },
      "insurer-search": {
        "title": "Изберете здравна осигуровка",
        "subtitle": "Моля, търсете и изберете вашата задължителна здравна осигуровка.",
        "placeholder": "Търсене на осигуровка...",
        "hint": "Въведете поне 2 символа за търсене.",
        "no-results": "Не е намерена осигуровка.",
        "no-results-hint": "Проверете правописа или опитайте друго търсене.",
        "label": "Име на вашата здравна каса",
        "search-error-v2": "Търсенето в момента не се получи. Опитайте отново.",
        "app-alternative": "Предпочитате приложението на здравната си каса?"
      },
      "insurer-contact": {
        "title": "Поискайте доказателство за застраховка",
        "subtitle": "Моля, изберете една от следните опции.",
        "or": "или",
        "option-eeb-title": "Заявка по електронен път",
        "option-eeb-description": "Ако е налице законовият изключителен случай, след Вашето съгласие можете да предадете заявката на екипа на практиката.",
        "option-qr-title": "Сканиране с приложение",
        "option-qr-description": "Сканирайте QR code с вашето застрахователно приложение.",
        "option-call-title": "Обади се сам",
        "option-call-description": "Обадете се на вашата застраховка и поискайте eEB за този лекарски кабинет:",
        "phone": "Телефон",
        "phone-not-available": "Телефонен номер на вашата застрахователна карта",
        "patient-name": "пациент",
        "practice-kim": "KIM адрес на лекарския кабинет",
        "help-notice": "Ако имате проблеми, моля, посетете рецепцията.",
        "submit-eeb-button": "Заявете сега",
        "contacted-button": "Обадих се",
        "contacted-button-countdown": "Време е за вашето обаждане ({{seconds}}s)",
        "go-to-counter-button": "Отидете на рецепцията",
        "qr-continue-button": "Сканирал съм",
        "qr-continue-button-countdown": "Време за сканиране ({{seconds}}s)",
        "title-v2": "Удостоверение от вашата здравна каса",
        "subtitle-v2": "Най-лесно е с приложението на здравната ви каса.",
        "subtitle-no-app": "Изберете как здравната ви каса да ни изпрати удостоверението.",
        "option-eeb-description-v2": "Ние ще поискаме удостоверението от касата вместо вас. За това ни е нужно вашето съгласие.",
        "call-instruction": "Обадете се на здравната си каса и помолете да изпратят удостоверението до нашата практика.",
        "call-instruction-practice": "Обадете се на здравната си каса и помолете да изпратят удостоверението до практиката {{practice}}.",
        "done-button": "Готово – напред",
        "done-button-countdown": "Готово – напред (още {{seconds}} с)"
      },
      "eeb-consent": {
        "title": "Съгласие",
        "subtitle": "Нуждаем се от вашето съгласие за електронна проверка на осигуровката.",
        "insurance": "Вашата осигуровка",
        "consent-title": "Съгласие за електронна проверка на осигуровката (eEB)",
        "consent-text": "Разбирам, че моята здравна застраховка ще предаде моите застрахователни данни (напр. име, дата на раждане, осигурителен номер) чрез защитената комуникационна услуга KIM до лекарския кабинет {{practiceName}} като доказателство за осигуряване. Съгласен/съгласна съм с това предаване. Наясно съм, че мога да оттегля това съгласие по всяко време, без това да повлияе на лечението ми.",
        "withdrawal-notice": "Можете да оттеглите това съгласие по всяко време.",
        "agree-button": "Съгласен съм",
        "decline-button": "Отказ",
        "treatment-notice": "Вашето лечение не е засегнато от това съгласие.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Удостоверение от вашата здравна каса",
        "summary": "Здравната ви каса ни изпраща удостоверението директно. За това ни е нужно вашето съгласие.",
        "confirm-first": "Първо потвърдете декларацията."
      },
      "qr-code": {
        "title": "Сканирай с приложението за осигуровка",
        "instruction-1": "Отворете вашето приложение за осигуровка и сканирайте този QR код.",
        "instruction-2": "След това лекарският кабинет автоматично ще получи потвърждението на вашата застраховка.",
        "practice": "Лекарски кабинет: {{name}}",
        "alternative-hint": "Алтернатива: Използвайте вашето приложение за осигуровка",
        "instruction-app": "Отворете приложението на здравната си каса и сканирайте този код. Удостоверението идва директно при нас.",
        "staff-line": "За екипа на практиката: {{address}}",
        "staff-line-practice": "За екипа на практиката: {{name}} · {{address}}",
        "alternative-app": "Можете да поискате удостоверението и чрез приложението на касата: отворете приложението и сканирайте този код."
      },
      "register-basics": {
        "title": "Лична информация",
        "subtitle": "Моля, въведете вашите данни.",
        "family-name": "Фамилия",
        "given-name": "Име",
        "dob": "Дата на раждане",
        "gender": "Пол",
        "insurance-type": "Тип осигуровка",
        "insurer-name": "Име на вашата застраховка",
        "insurer-name-placeholder": "напр. Дебека, DKV, Allianz...",
        "gender-required": "Изберете една възможност."
      },
      "register-insurer": {
        "title": "Здравна осигуровка",
        "subtitle": "Моля, изберете вашата здравна осигуровка.",
        "search-placeholder": "Търсене на осигуровка..."
      },
      "register-details": {
        "title": "Резюме",
        "subtitle": "Моля, прегледайте вашата информация.",
        "create": "Завърши регистрацията",
        "missing-data": "Моля, попълнете всички задължителни полета.",
        "create-error": "Регистрацията е неуспешна. Моля, опитайте отново.",
        "policy-number": "Номер на полицата (по избор)",
        "policy-number-placeholder": "Номерът на вашата полица",
        "create-v2": "Завършване на регистрацията",
        "policy-number-hint": "Номера ще намерите на картата на осигуровката си."
      },
      "diff-review": {
        "eyebrow-chip": "Преглед",
        "eyebrow": "Чекиране · данни на картата",
        "title": "Сравнение на данни",
        "subtitle": "Открити са разлики между данните от вашата карта и нашите записи.",
        "col-current": "Текущ рекорд",
        "col-new": "Ново от карта",
        "new-badge": "нов",
        "field-fallback": "Поле",
        "note": "Актуализираните данни ни помагат да таксуваме правилно и да се свържем с вас при спешни случаи.",
        "comparison-placeholder": "Сравнението ще бъде показано тук",
        "confirm": "Потвърди промените",
        "apply-error": "Данните не можаха да бъдат приложени. Моля, опитайте отново.",
        "retry": "Опитайте отново",
        "skip": "Продължете все пак",
        "no-changes": "Не са открити промени",
        "title-v2": "Данните ви са се променили",
        "subtitle-v2": "На картата ви има по-нови данни. Да ги поемем ли?",
        "confirm-v2": "Поемане и регистрация",
        "keep": "Регистрация без промяна",
        "col-current-v2": "Досега",
        "col-new-v2": "Ново от картата",
        "value-yes": "Да",
        "value-no": "Не"
      },
      "insurance-selection": {
        "title": "Тип осигуровка",
        "subtitle": "Моля, изберете вашия тип осигуровка.",
        "gkv": "Законово осигурен",
        "gkv-description": "Член на задължителна здравна осигуровка.",
        "pkv": "Частна или самоплащане",
        "pkv-description": "Частно осигурен или самоплащане.",
        "pkv-description-v2": "Частна здравна осигуровка или плащате сами."
      },
      "eeb-request": {
        "title": "Заявката е регистрирана",
        "subtitle": "Можете да завършите регистрацията. Отговорът от {{insurer}} ще пристигне в практиката по-късно.",
        "verifying": "Вашата заявка е приета за незабавна обработка.",
        "success": "Вашата заявка беше предадена сигурно на екипа на практиката.",
        "error": "Потвърждението на заявката не е налично.",
        "try-alternative": "Алтернативен метод",
        "kim-load-error": "KIM адресът на лекарския кабинет не можа да бъде зареден.",
        "kim-label": "Лекарски кабинет · KIM",
        "non-blocking-note": "Това все още не потвърждава получаването от Вашата здравна каса или Вашия осигурителен статус.",
        "auto-continue": "Автоматично продължаване след {{seconds}} секунди.",
        "unavailable-title": "За съжаление не се получи",
        "unavailable-v2": "Заявката ви към здравната каса не можа да бъде регистрирана.",
        "unavailable-body": "Можете да поискате удостоверението чрез приложението на касата или да уредите въпроса на рецепцията.",
        "use-app": "С приложението",
        "at-reception": "Уреждане на рецепцията"
      },
      "self-pay": {
        "title": "Самоплащане",
        "subtitle": "Ще бъдете третиран като пациент със самоплащане.",
        "info": "Моля, имайте предвид, че ще носите отговорност за разходите за лечение.",
        "confirm": "Разбрах",
        "title-v2": "Плащате сами",
        "subtitle-v2": "Плащате лечението сами.",
        "insured-after-all": "Все пак съм осигурен"
      },
      "done": {
        "title": "Готово!",
        "subtitle": "Вашата регистрация е завършена.",
        "finish": "Край",
        "done-label": "Готово",
        "error-label": "Забележете",
        "eyebrow": "Настаняване · завършено",
        "queue-label": "Чакалня",
        "queue-title": "Моля, седнете",
        "queue-meta": "Ще ви се обадим лично.",
        "success-title": "Успешна регистрация!",
        "success-subtitle": "Моля, заемете място в чакалнята. Ще бъдете повикани.",
        "auto-redirect": "Скоро ще бъдете пренасочени към началната страница...",
        "auto-redirect-countdown": "Връщане в началото след {{seconds}} секунди...",
        "card-expired-title": "Картата е изтекла",
        "card-expired-subtitle": "Вашата здравна карта е изтекла.",
        "card-expired-info": "Моля, свържете се с персонала за помощ.",
        "back-to-start": "Обратно към начало",
        "anamnesis-title": "Пълен формуляр за медицинска история",
        "anamnesis-description": "Сканирайте QR code, за да попълните удобно формуляра за медицинска история на вашия смартфон.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Регистрирани сте",
        "card-expired-info-v2": "Обърнете се към рецепцията."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Проверете данните си",
          "balance-prefix": "При запазване:",
          "balance-direct-v2": "Запазено веднага: {{count}}",
          "balance-reception-v2": "Проверява рецепцията: {{count}}",
          "chip-reception-v2": "Промените се проверяват от нашата рецепция",
          "chip-changed": "Променено: {{count}}",
          "remove": "Премахване",
          "example-email": "напр. ime@primer.bg",
          "example-phone": "напр. 0888 123 456",
          "intro-v2": "Регистрацията ви е готова. Тези данни още ли са верни? Проверката е доброволна.",
          "auto-hide": "Показаните стойности отново се скриват след кратко време."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Предадохме тази информация на рецепцията.",
          "banner-done-v2": "Благодарим! Получихме данните ви.",
          "footer-v2": "Всички други данни остават както са."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "От съображения за защита на данните затворихме показването. Регистрацията ви въпреки това е готова. Можете по всяко време да съобщите промени на рецепцията."
        }
      },
      "progress": {
        "identify": "Регистрация",
        "insurance": "Осигуровка",
        "done": "Готово"
      },
      "dob-format-hint": "Например 01.10.1980",
      "dob-required": "Въведете датата си на раждане.",
      "insurance-label": {
        "GKV": "Задължително осигурен",
        "PKV": "Частно осигурен",
        "SELFPAY": "Плащане от пациента"
      }
    },
    "emergency": {
      "title": "Остра спешност!",
      "label": "Спешен случай",
      "subtitle": "Тази сигнализация се чува само на място и не е повикала помощ. При остър или потенциално животозастрашаващ случай се обадете на 112.",
      "call-emergency": "Обадете се на службите за спешна помощ (112)",
      "stop-sound": "Спиране на звука",
      "play-sound": "Възпроизвеждане на звук",
      "back-to-start": "Назад към началото",
      "headline": "Моля, незабавно се обърнете към персонала на рецепцията. При опасност за живота се обадете на 112."
    },
    "help-reception": "Помощ на рецепцията",
    "help-reception-toast": "Моля, свържете се с рецепцията. Радваме се да помогнем.",
    "language-entry": {
      "title": "Изберете език"
    },
    "loading": "Зареждане…",
    "step-progress-label": "Напредък",
    "step-progress-phase": "Раздел {{current}} от {{total}}: {{phase}}",
    "step-progress-substep": "Част {{current}} от {{total}}",
    "step-progress-complete": "Завършено",
    "identification": {
      "title": "Кой сте вие?",
      "lead": "Най-бързо е със здравноосигурителната ви карта. Можете да търсите и по име.",
      "lead-card-only": "Моля, поставете здравноосигурителната си карта в четеца за карти.",
      "mode-label": "Как искате да се регистрирате?",
      "mode-card": "С карта",
      "mode-search": "Търсене по име",
      "mode-create": "Нов пациент",
      "card": {
        "loading": "Четецът за карти се подготвя …",
        "checking": "Четецът за карти се проверява …",
        "insert-title": "Моля, поставете здравноосигурителната си карта в четеца за карти.",
        "insert-detail": "Четем данните ви автоматично.",
        "detected": "Картата е разпозната",
        "read": "Прочети картата",
        "reading": "Картата се чете …",
        "reading-hint": "Моля, оставете картата в четеца.",
        "no-terminal-title": "Четецът за карти не е наличен",
        "help-with-search": "Моля, потърсете по име или попитайте на рецепцията.",
        "help-reception": "Моля, попитайте на рецепцията – с удоволствие ще помогнем.",
        "unreadable-title": "Картата е разпозната, но не може да се прочете",
        "error-title": "Картата не можа да бъде прочетена",
        "not-unique": "Не успяхме еднозначно да ви свържем с тази карта. Моля, потърсете по име или попитайте на рецепцията.",
        "no-match": "Не намерихме данни за тази карта. Моля, потърсете по име или попитайте на рецепцията.",
        "without-card": "Продължи без карта"
      },
      "lookup": {
        "lead": "Моля, въведете фамилията и датата си на раждане.",
        "first-name": "Име",
        "last-name": "Фамилия",
        "dob": "Дата на раждане",
        "dob-hint": "Формат: ДД.ММ.ГГГГ",
        "search": "Търсене",
        "confirm": "Да, това съм аз",
        "found-title": "Намерихме ви",
        "found-body": "Моля, потвърдете, че става дума за вас.",
        "first-name-needed-title": "Моля, добавете малкото си име",
        "first-name-needed-body": "За да ви намерим еднозначно. След това докоснете „Търсене“.",
        "ambiguous-title": "Не успяхме да ви намерим еднозначно",
        "ambiguous-body": "Моля, попитайте на рецепцията – с удоволствие ще помогнем.",
        "not-found-title": "Няма съответстващи данни",
        "not-found-body": "Моля, проверете въведените данни.",
        "error-title": "Търсенето в момента не е възможно",
        "error-body": "Моля, опитайте отново или попитайте на рецепцията."
      },
      "create": {
        "insurance-question": "Как сте осигурени?",
        "insurance-required": "Моля, изберете как сте осигурени.",
        "error-title": "Данните ви не можаха да бъдат запазени",
        "error-body": "Моля, опитайте отново или попитайте на рецепцията."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Първо отключете",
      "subtitle": "FrontDesk+ трябва да се активира във вашия софтуер за практикуване.",
      "step1": "Поръчайте в SolStore (или вашият Doc-Cirrus партньор поръчва вместо вас).",
      "step2": "След активиране, активирайте в inSuite под „inSuite Sols“ (права на администратор).",
      "step3": "Отворете администрацията на Bridge → „Добавяне на устройство“.",
      "cta": "Готово - продължете напред"
    },
    "welcome": {
      "title": "Добавете това устройство към практиката",
      "scan": "Направете снимка на кода",
      "prepare-link": "Няма код в inSuite?",
      "language": "език"
    },
    "scan": {
      "requesting": "Иска се достъп до камерата...",
      "scanning": "Насочете камерата към кода",
      "paste": "Поставете вместо това",
      "manual-title": "Свържете ръчно",
      "manual-description": "Ако QR кодът не е наличен, вземете данните за връзката от администрацията на Bridge.",
      "address-label": "Bridge адрес",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Поставете SOLTOKEN",
      "manual-submit": "Поемете връзката",
      "error-title": "Кодът не е разпознат",
      "camera-denied-title": "Достъпът до камерата е отказан",
      "camera-denied-hint": "Моля, разрешете достъп до камерата в настройките и опитайте отново.",
      "retry": "Опитайте отново"
    },
    "preflight": {
      "title": "Ще бъде настроен",
      "all-green": "Всички тестове преминаха",
      "practice": "Практикувайте",
      "device-name": "Име на устройството",
      "device-name-placeholder": "напр. Б. Рецепция 1",
      "card-reader": "Четец на карти",
      "pin": "Нов таен номер",
      "pin-placeholder": "Четирицифрен ПИН",
      "finish": "Завършете",
      "recheck": "Проверете отново",
      "diagnosis": "ID на диагнозата",
      "checklist-error": "Bridge отказа връзката или е недостъпен. Проверете SOLTOKEN и адреса на Bridge.",
      "checklist-retry": "Проверете отново",
      "edit-token": "Променете SOLTOKEN",
      "rescan": "Сканирайте кода отново"
    },
    "persisting": "Настройката се запазва …",
    "success": {
      "title": "Устройството е добавено",
      "detail": "Устройството току-що се появи на практическия компютър.",
      "starting": "Режимът на пациент започва..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Връзка с учебния софтуер",
        "fix": "Bridge Проверете връзката и адреса на сървъра."
      },
      "missing_insuite_url": {
        "label": "inSuite адрес",
        "fix": "Сканирайте QR кода отново - адресът липсва."
      },
      "missing_server_token": {
        "label": "Сървърен токен",
        "fix": "Сканирайте отново QR кода - токенът липсва."
      },
      "missing_gateway_session": {
        "label": "Gateway сесия",
        "fix": "Влезте отново — сесията липсва."
      },
      "missing_gateway_enrollment": {
        "label": "Регистрация на устройството",
        "fix": "Регистрирайте устройството на Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway готовност",
        "fix": "Изчакайте Gateway да завърши настройката."
      },
      "token_verification_failed": {
        "label": "Проверка на токена",
        "fix": "Проверете токена на сървъра или Bridge връзката."
      },
      "session_expired": {
        "label": "среща",
        "fix": "Сесията е изтекла - влезте отново."
      },
      "device_revoked": {
        "label": "Състояние на устройството",
        "fix": "Това устройство е блокирано. Свържете се с практиката."
      },
      "missing_practice_name": {
        "label": "Име на практиката",
        "fix": "Името на медицинската практика не можа да бъде заредено (inSuite)."
      },
      "missing_device_name": {
        "label": "Име на устройството",
        "fix": "Моля, въведете име на устройство."
      },
      "telematik_unavailable": {
        "label": "Телематична инфраструктура",
        "fix": "По избор — проверката на картата остава възможна веднага щом TI е наличен."
      },
      "selected_card_reader_unavailable": {
        "label": "Четец на карти",
        "fix": "По избор — изберете или свържете четец на карти."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "По избор — поставете идентификационната карта на медицинската практика (SMC-B)."
      }
    },
    "token": {
      "title": "Въведете SOLTOKEN",
      "description": "От съображения за сигурност QR кодът не съдържа SOLTOKEN. Копирайте го в inSuite в „Sol-Aktivierung“ (FrontDesk+) и го поставете тук.",
      "submit": "Напред",
      "rescan": "Сканирайте кода отново"
    }
  }
}
